import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCrossSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M8.25 6.12891L12 9.87891L15.75 6.12891L17.8713 8.25023L14.1213 12.0002L17.8713 15.7502L15.75 17.8715L12 14.1215L8.25 17.8715L6.12868 15.7502L9.87868 12.0002L6.12868 8.25023L8.25 6.12891Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrossSmall;
